import styled from '@emotion/styled';

import useIntersectionAnimate from '../../../hooks/useIntersectionObserver';
// import ComponentHeader from '../../../components/ComponentHeader/ComponentHeader';
import VehicleTypeCard from '../../../components/Card/VehicleTypeCard';

const OurVehicles = () => {
  useIntersectionAnimate('.intersection-animate', 'animate', {
    threshold: 0.1,
  });

  const vehicles = [
    { name: 'Bicycles', img: '/static/img/cml/bicycles.png' },
    { name: 'Dispatch bikes', img: '/static/img/cml/bikes.png' },
    { name: 'Tricycles', img: '/static/img/cml/tricycles.png' },
    { name: 'Vans', img: '/static/img/cml/vans.png' },
    { name: 'Trucks', img: '/static/img/cml/trucks.png' },
    { name: 'Lorries', img: '/static/img/cml/lorries.png' },
  ];

  return (
    <Container className='intersection-animate'>
      <Header>You are who we are looking for if you have a fleet of</Header>
      <CardsGrid>
        {vehicles.map((vehicle) => (
          <VehicleTypeCard
            key={vehicle.name}
            vehicleName={vehicle.name}
            imageSrc={vehicle.img}
          />
        ))}
      </CardsGrid>
    </Container>
  );
};

export default OurVehicles;

const Container = styled.div`
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  gap: 40px;

  &.animate {
    --ydist: 100%;

    & > * {
      animation-duration: 0.3s;
      animation-delay: 0.3s;
      animation-timing-function: ease-out;
      animation-fill-mode: backwards;
    }

    & > *:first-of-type {
      animation-name: header-translate, text-opacity;
      animation-delay: 0.5s;
    }

    & > *:last-of-type {
      --ydist: 50%;
      animation-name: header-translate;
    }

    @keyframes header-translate {
      from {
        transform: translateY(var(--ydist));
      }
      to {
        transform: 0;
      }
    }

    @keyframes text-opacity {
      from {
        opacity: 0;
      }
      50% {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }

  @media (max-width: 884px) {
    align-items: center;
    padding-bottom: 55px;
  }
`;

const Header = styled.h1`
    max-width: 80%;
    font-weight: 700;
    font-style: Bold;
    font-size: 25px;
    leading-trim: NONE;
    line-height: 130%;
    letter-spacing: -2%;
    text-align: center;

    @media (max-width: 884px) {
        font-size: 20px;
        line-height: 24px;
    }
`;

const CardsGrid = styled.div`
  display: grid;
  gap: 20px;
  width: 100%;
  place-items: center;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: 884px) {
    grid-template-columns: 1fr 1fr;
  }
`;


